import { useLocation } from "react-router";
import { CITIES } from "../constants";
import { SYSTEMS } from "../permissions";

/** True when route is under `/app/makkah/...` or `/app/madina/...` (platform chosen). */
export const isAppPlatformSelected = (currentSystem) =>
  currentSystem === "makkah" || currentSystem === "madina";

/**
 * Resolves `makkah` | `madina` from `/app/(makkah|madina)/...`.
 * Avoids `split("/")[2]` breaking when a basename or extra segments appear before `/app/`.
 */
export const parseAppPlatformCode = (pathname = "") => {
  const m = pathname.match(/\/app\/(makkah|madina)(?:\/|$|\?|#)/);
  if (m) return m[1];
  const segs = pathname.split("/").filter(Boolean);
  const i = segs.indexOf("app");
  if (i >= 0 && (segs[i + 1] === "makkah" || segs[i + 1] === "madina")) {
    return segs[i + 1];
  }
  return "";
};

export const useSystem = () => {
  const location = useLocation();
  const path = location.pathname || "";
  const currentSystem = parseAppPlatformCode(path);

  const city_id = currentSystem === "madina" ? CITIES.madina.id : CITIES.makkah.id;

  const from_id = currentSystem === SYSTEMS.MAKKAH.code ? 1 : 2;
  const port = currentSystem === SYSTEMS.MAKKAH.code ? "JED" : "MED";

  return {
    currentSystem,
    location,
    city_id,
    from_id,
    port,
    isMakkah: currentSystem === SYSTEMS.MAKKAH.code,
  };
};